document.addEventListener('DOMContentLoaded', function () {
  const registerForm = document.getElementById('create_customer');
  const signInClose = document.querySelectorAll('.sign-in__close');
  let handleBackSignClick;

  function setupValidation(formId, fields) {
    const forms = document.querySelectorAll(`#${formId}`);
    if (!forms.length) return;

    forms.forEach((form) => {
      const requiredInputs = form.querySelectorAll('input[name^="customer"]');
      const emailInput = form.querySelector('input[name="customer[email]"]');
      const passwordInput = form.querySelector('input[name="customer[password]"]');
      const confirmPasswordInput = form.querySelector('input[name="customer[password_confirmation]"]');
      const dobInput = form.querySelector('input[name="customer[note]"]');

      const validate = {
        email: (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email),
        passwordComplexity: (password) =>
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d@$!%*?&_^])[A-Za-z\d@$!%*?&_^]{8,}$/.test(password),
        passwordConfirmation: (password, confirmPassword) => password === confirmPassword,
        dob: (dob) => new Date(dob) <= new Date(),
      };

      const errorMessages = {
        email: 'Please enter your email in the following format: yourname@mail.com',
        passwordComplexity:
          'Requires at least 8 characters including uppercase, lowercase, number, or special character',
        passwordConfirmation: 'Password and confirm password do not match.',
        dob: 'Please select a valid date of birth.',
        required: (fieldName) => {
          const messages = {
            'customer[first_name]': 'Please enter your first name.',
            'customer[last_name]': 'Please enter your last name.',
            'customer[email]': 'Please enter your email address.',
            'customer[password]': 'Please enter your password.',
            'customer[password_confirmation]': 'Please confirm your password.',
            'customer[note]': 'Please enter your date of birth (yyyy/mm/dd).',
          };
          return messages[fieldName] || 'This field is required.';
        },
      };

      function showError(parentDiv, errorMessage) {
        if (!parentDiv) return;

        let errorParagraph = parentDiv.querySelector('.error');
        if (errorParagraph) {
          errorParagraph.textContent = errorMessage;
        } else {
          errorParagraph = document.createElement('p');
          errorParagraph.classList.add(
            'text-body-sm',
            'md:text-13',
            'font-325',
            'text-brand-red',
            'mt-2',
            'hidden',
            'group-[.error]/field:block',
            'error'
          );
          errorParagraph.textContent = errorMessage;
          parentDiv.appendChild(errorParagraph);
        }
        parentDiv.classList.add('error', 'group/field');
      }

      function handleInputValidation(input, validationFn, errorMessage) {
        if (!input) return;

        input.addEventListener('input', function () {
          const parentDiv = input.closest('.input-container');
          if (!parentDiv) return;

          if (input.value.trim() !== '' && !validationFn(input.value.trim())) {
            showError(parentDiv, errorMessage);
          } else {
            parentDiv.classList.remove('error', 'group/field');
            const errorParagraph = parentDiv.querySelector('.error');
            if (errorParagraph) {
              parentDiv.removeChild(errorParagraph);
            }
          }
        });
      }

      requiredInputs.forEach((input) => {
        input.addEventListener('input', function () {
          const parentDiv = input.closest('.input-container');
          if (!parentDiv) return;

          if (input.value.trim() !== '') {
            parentDiv.classList.remove('error', 'group/field');
            const errorParagraph = parentDiv.querySelector('.error');
            if (errorParagraph) {
              parentDiv.removeChild(errorParagraph);
            }
          }
        });
      });

      if (emailInput) {
        handleInputValidation(emailInput, validate.email, errorMessages.email);
      }

      if (fields.includes('passwordComplexity') && passwordInput) {
        handleInputValidation(passwordInput, validate.passwordComplexity, errorMessages.passwordComplexity);
      }

      if (fields.includes('passwordConfirmation') && confirmPasswordInput) {
        handleInputValidation(
          confirmPasswordInput,
          (value) => validate.passwordConfirmation(passwordInput.value.trim(), value),
          errorMessages.passwordConfirmation
        );
      }

      if (fields.includes('dob') && dobInput) {
        handleInputValidation(dobInput, validate.dob, errorMessages.dob);
        const today = new Date().toISOString().split('T')[0];
        dobInput.setAttribute('max', today);
      }

      form.addEventListener('submit', function (event) {
        let isValid = true;

        requiredInputs.forEach((input) => {
          const parentDiv = input.closest('.input-container');
          if (!parentDiv) return;

          if (input.value.trim() === '') {
            isValid = false;
            showError(parentDiv, errorMessages.required(input.getAttribute('name')));
          }
        });

        if (emailInput && !validate.email(emailInput.value.trim())) {
          showError(emailInput.closest('.input-container'), errorMessages.email);
          isValid = false;
        }

        if (
          fields.includes('passwordComplexity') &&
          passwordInput &&
          !validate.passwordComplexity(passwordInput.value.trim())
        ) {
          showError(passwordInput.closest('.input-container'), errorMessages.passwordComplexity);
          isValid = false;
        }

        if (
          fields.includes('passwordConfirmation') &&
          confirmPasswordInput &&
          !validate.passwordConfirmation(passwordInput.value.trim(), confirmPasswordInput.value.trim())
        ) {
          showError(confirmPasswordInput.closest('.input-container'), errorMessages.passwordConfirmation);
          isValid = false;
        }

        if (fields.includes('dob') && dobInput && !validate.dob(dobInput.value.trim())) {
          showError(dobInput.closest('.input-container'), errorMessages.dob);
          isValid = false;
        }

        if (!isValid) {
          event.preventDefault();
        }
      });
    });
  }

  const queryString = window.location.search;
  const emailExists = document.getElementById('email-exists-message');
  if (queryString.includes('return=true') && emailExists) {
    emailExists.classList.remove('hidden');
  } else if (emailExists) {
    emailExists.classList.add('hidden');
  }

  setupValidation('create_customer', ['passwordComplexity', 'passwordConfirmation', 'dob']);
  setupValidation('customer_login_main', []);
  setupValidation('customer_login_drawer', []);
  setupValidation('customer_login_hamburger', []);
  setupValidation('reset_password', ['passwordComplexity', 'passwordConfirmation']);

  function initializePasswordReset() {
    const resetForms = document.querySelectorAll('#recoverPasswordForm');
    resetForms.forEach((recoverPasswordForm) => {
      const resetPasswords = recoverPasswordForm.closest('#recover');
      const loginForms = document.querySelectorAll('.login__form');
      const forgotPassLinks = document.querySelectorAll('.forgot-pass');
      const backSigns = document.querySelectorAll('.back-sign');
      const resetButtons = document.querySelectorAll('.reset-button');
      const recoverMsgs = document.querySelectorAll('.recover-msg');
      const emailInput = recoverPasswordForm.querySelector('input[name="email"]');
      const emailLabels = recoverPasswordForm.querySelectorAll('label[for="email"]');
      const signinHeading = document.querySelector('.model-content__heading');

      if (
        !resetPasswords ||
        !loginForms.length ||
        !forgotPassLinks.length ||
        !backSigns.length ||
        !recoverMsgs.length ||
        !emailInput
      ) {
        console.error('One or more elements not found in the DOM.');
        return;
      }

      resetPasswords.style.display = 'none';
      recoverMsgs.forEach((msg) => {
        msg.style.display = 'none';
      });

      const validateEmail = (email) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
      };

      const showError = (message) => {
        let errorParagraph = emailInput.closest('.input-container').querySelector('.error');
        if (!errorParagraph) {
          errorParagraph = document.createElement('p');
          errorParagraph.classList.add(
            'text-body-sm',
            'md:text-13',
            'font-325',
            'text-brand-red',
            'mt-2',
            'hidden',
            'group-[.error]/field:block',
            'error'
          );
          emailInput.closest('.input-container').appendChild(errorParagraph);
        }
        errorParagraph.textContent = message;
        emailInput.closest('.input-container').classList.add('error', 'group/field');
      };

      const clearError = () => {
        const errorParagraph = emailInput.closest('.input-container').querySelector('.error');
        if (errorParagraph) {
          errorParagraph.textContent = '';
          emailInput.closest('.input-container').classList.remove('error', 'group/field');
        }
      };

      const handleForgotPassClick = (e) => {
        e.preventDefault();
        resetPasswords.style.display = 'block';
        loginForms.forEach((form) => {
          form.style.display = 'none';
        });
        signinHeading.style.display = 'none';
      };

      handleBackSignClick = () => {
        resetPasswords.style.display = 'none';
        loginForms.forEach((form) => {
          form.style.display = 'block';
        });
        signinHeading.style.display = 'block';
      };

      const handleEmailInput = () => {
        const email = emailInput.value.trim();
        if (!validateEmail(email)) {
          showError('Please enter a valid email address.');
        } else {
          clearError();
        }
      };

      const handleFormSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(recoverPasswordForm);
        const email = formData.get('email').trim();

        if (!validateEmail(email)) {
          showError('Please enter a valid email address.');
          return;
        } else {
          clearError();
        }

        fetch('/account/recover', {
          method: 'POST',
          body: formData,
          headers: {
            Accept: 'application/json',
          },
        })
          .then((response) => {
            if (response.ok) {
              recoverMsgs.forEach((msg) => {
                msg.style.display = 'block';
                msg.classList.remove('mb-8');
              });
              document.querySelectorAll('.reset-msg').forEach((resetMsg) => {
                resetMsg.style.display = 'none';
              });
              //   const emailInputContainer = document.querySelector('.recover_password');
              //   if (emailInputContainer) {
              //     emailInputContainer.classList.add('opacity-0');
              //   }
              emailLabels.forEach((label) => {
                if (label) {
                  label.classList.add('opacity-0');
                }
              });
              resetButtons.forEach((resetButton) => {
                resetButton.style.transform = 'translateY(-80px)';
                resetButton.textContent = 'RESEND EMAIL';
              });
              backSigns.forEach((backSign) => {
                backSign.style.transform = 'translateY(-90px)';
              });
            } else {
              recoverMsgs.forEach((msg) => {
                msg.style.display = 'block';
                msg.textContent = 'Something went wrong, please try again later.';
              });
              document.querySelectorAll('.reset-msg').forEach((resetMsg) => {
                resetMsg.style.display = 'none';
              });
            }
          })
          .catch((error) => console.error('Error:', error));
      };

      forgotPassLinks.forEach((link) => {
        link.addEventListener('click', handleForgotPassClick);
      });
      backSigns.forEach((link) => {
        link.addEventListener('click', handleBackSignClick);
      });
      emailInput.addEventListener('input', handleEmailInput);
      recoverPasswordForm.addEventListener('submit', handleFormSubmit);
    });
  }

  initializePasswordReset();

  if (registerForm) {
    registerForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = new FormData(registerForm);
      fetch('/account', {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json',
        },
      })
        .then((response) => {
          if (response.ok) {
            window.location.href = '/account/register?return=true';
          } else {
            throw new Error('Something went wrong, please try again later.');
          }
        })
        .catch((error) => console.error('Error:', error));

      form.reset();
    });
  }

  if (signInClose) {
    signInClose.forEach((close) => {
      close.addEventListener('click', function () {
        handleBackSignClick();
      });
    });
  }
});
